/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Add_New_PlayerInputs */



/**
* | output |
* | --- |
* | "Add New Player (Offline)" |
*
* @param {Offline_Add_New_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_add_new_player = /** @type {((inputs?: Offline_Add_New_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Add_New_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un joueur (hors ligne)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir jugador (sin conexión)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicionar jogador (offline)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi giocatore (offline)")
	return /** @type {LocalizedString} */ ("Add New Player (Offline)")
});